import {RiCloseLine} from 'react-icons/ri'
import Popup from 'reactjs-popup'
import './index.css'

const Rules = () => (
  <div className="popup-container">
    <Popup
      modal
      trigger={
        <div className="rules_button_div">
          <div className="rules_button_div_a">
            <button type="button" className="rules-button">
              RULES
            </button>
          </div>
        </div>
      }
    >
      {close => (
        <div className="pop_container">
          <div className="pop_container_1">
            <button
              type="button"
              className="close-button"
              onClick={() => close()}
            >
              <RiCloseLine />
            </button>
          </div>
          <div className="rules_image_div">
            <img
              className="rules_img"
              alt="rules"
              src="https://assets.ccbp.in/frontend/react-js/rock-paper-scissor/rules-image.png "
            />
          </div>
        </div>
      )}
    </Popup>
  </div>
)
export default Rules
